"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var CalendarTrackingSmallFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_CalendarTrackingSmallFill_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 15,
    height: 15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.504 3.5v-2a.5.5 0 0 0-1 0v2a.5.5 0 0 0 1 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.002 1.875h4.001V3.5a1 1 0 0 0 2 0V1.904c.59.036 1.007.116 1.363.298.281.143.536.328.756.548h.008v.007a3 3 0 0 1 .548.756c.194.381.273.832.305 1.487H1.022c.032-.655.11-1.106.305-1.487a3 3 0 0 1 .548-.756V2.75h.008a3 3 0 0 1 .756-.548c.356-.182.774-.262 1.362-.298V3.5a1 1 0 0 0 2 0V1.875ZM1 6.675 1.001 6h10.95a3.438 3.438 0 0 0-.82.607L9.777 7.961a1.499 1.499 0 0 0-.396 1.42 1.5 1.5 0 0 0-1.421.396L6.608 11.13A3.44 3.44 0 0 0 5.916 15h-.114c-1.681 0-2.521 0-3.163-.327a3.001 3.001 0 0 1-.756-.548h-.008v-.007a3 3 0 0 1-.548-.756C1 12.72 1 11.88 1 10.2V6.675Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.502 1.5a.5.5 0 0 0-1 0v2a.5.5 0 0 0 1 0v-2ZM13.933 12.116l1.353-1.353a2.44 2.44 0 0 0-3.448-3.449l-1.353 1.354a.5.5 0 0 0 .707.706l1.353-1.353a1.438 1.438 0 1 1 2.034 2.035l-1.353 1.354a.5.5 0 0 0 .707.706ZM7.316 11.837a2.44 2.44 0 0 0 3.448 3.449l1.352-1.354a.5.5 0 0 0-.706-.706l-1.353 1.353a1.438 1.438 0 1 1-2.035-2.035l1.353-1.353a.5.5 0 0 0-.706-.707l-1.353 1.353Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.036 12.562a.5.5 0 0 1 0-.707l1.816-1.816a.5.5 0 1 1 .706.707l-1.815 1.816a.5.5 0 0 1-.707 0Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_CalendarTrackingSmallFill_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = CalendarTrackingSmallFill;
exports["default"] = _default;